<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>


    <div v-if="!modoEdicao">
        <div class="form-edit-page row-space">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Pasta</label>
                    <div class="field-label field-label-end">{{ Funcoes.formatInteger(objView.id) }}</div>
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome/Identificação</label>
                    <div class="field-label">{{ objView.nmpasta }}</div>
                </div>
            </div>

            <div class="row-end">
                <button type="button" @click="novoArquivo">Novo Arquivo</button>
                <button type="button" @click="closeForm">Retornar</button>
            </div>
        </div>


        
        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead><tr>
                <th class="col-width-char10">Data</th>
                <th>Nome/Dscrição</th>
                <th class="col-width-char10">Situação</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td class="center">{{ Funcoes.formatDateFromJson(obj.dtanexo) }}</td>
                    <td>{{ obj.nmdoc }}</td>
                    <td  class="center">{{ obj.nmativo }}</td>
            </tr></tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoEdicao">
        <AnexoUploadPage :idAnexoGrupo="7" :idDrivePasta="objView.id" @close="modoEdicao = false" @save="listarArquivos" />
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import AnexoUploadPage from '@/components/operacoes/AnexoUploadPage.vue';

const emit = defineEmits(['close']);
const props = defineProps({idPasta: {type: Number, default: 0}});

const msgAlerta = ref(null);
const idEdicao = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const objView = ref({});

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const editarCadastro = (obj) => {
    idEdicao.value = obj.id;
    modoEdicao.value = true;
};

const lerDados = async() => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/drive/pastas', {
            idep: globalStore.idep,
            id: props.idPasta});
        Object.assign(objView.value, req[0]);
        listarArquivos();
    } catch (error){msgAlerta.value= error;
    } finally {isLoading.value = false;}
}


async function listarArquivos(){
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/drive/arquivos', {
            idep: globalStore.idep,
            intparam1: objView.value.id});
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value= error;
    } finally {isLoading.value = false;}
}

function novoArquivo() {
    idEdicao.value = 0;
    modoEdicao.value = true;
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>